import { render, staticRenderFns } from "./img-scale.vue?vue&type=template&id=1a02d3b0&scoped=true&"
import script from "./img-scale.vue?vue&type=script&lang=ts&"
export * from "./img-scale.vue?vue&type=script&lang=ts&"
import style0 from "./img-scale.vue?vue&type=style&index=0&id=1a02d3b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@5.2.7_vue-template-compiler@2.6.11_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a02d3b0",
  null
  
)

export default component.exports